export const actionTypes = {
  GET_WS_PARTNERS: "GET_WS_PARTNERS",
  SET_WS_PARTNERS: "SET_WS_PARTNERS",
  CREATE_WS_PARTNERS: "CREATE_WS_PARTNERS",
  UPDATE_WS_PARTNERS: "UPDATE_WS_PARTNERS",

  GET_CNPJ: "GET_CNPJ",
  SET_CNPJ: "SET_CNPJ",
  CNPJ_LOADER: "CNPJ_LOADER",
};

export const actions = {
  getWsPartners: (payload) => ({
    type: actionTypes.GET_WS_PARTNERS,
    payload: payload,
  }),

  setWsPartners: (payload) => ({
    type: actionTypes.SET_WS_PARTNERS,
    payload: payload,
  }),

  createWsPartners: (payload) => ({
    type: actionTypes.CREATE_WS_PARTNERS,
    payload: payload,
  }),

  updateWsPartners: (payload) => ({
    type: actionTypes.UPDATE_WS_PARTNERS,
    payload: payload,
  }),

  getCnpj: (payload) => ({
    type: actionTypes.GET_CNPJ,
    payload: payload,
  }),

  setCnpj: (payload) => ({
    type: actionTypes.SET_CNPJ,
    payload: payload,
  }),

  cnpjLoader: (payload) => ({
    type: actionTypes.CNPJ_LOADER,
    payload: payload,
  }),
};
